;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('InputNumberController', InputNumberController)

  /* @ngInject */
  function InputNumberController ($scope, Utils) {
    const api = {
      _checkForLinks
    }
    this.getApi = () => api

    activate()

    function activate () {
      _checkForLinks()
    }

    $scope.onChange = function (newValue) {
      if (!newValue) {
        return
      }

      newValue = Number(newValue.toString().replace(/[^0-9]/g, ''))

      if ($scope.maxValue && !$scope.validate(newValue, $scope.maxValue)) {
        newValue = $scope.maxValue
      }

      if ($scope.minValue && !$scope.validate($scope.minValue, newValue)) {
        newValue = $scope.minValue
      }

      $scope.model = newValue

      if ($scope.change) {
        $scope.change({
          modelPropertyName: $scope.modelPropertyName,
          modelNewValue: newValue
        })
      }
    }

    $scope.validateNumberOnly = function (event) {
      if (!/^\d+$/.test(event.key) && event.key.length === 1) {
        event.preventDefault()
      }
    }

    $scope.validate = (value, limit) => {
      if (limit && limit >= value) {
        return true
      }

      return false
    }

    function handleNumberInputsScroll () {
      const numberInputs = document.querySelectorAll('input[type="number"]')

      numberInputs.forEach(input => {
        input.addEventListener('wheel', event => {
          event.preventDefault()
        })
      })
    }

    function _checkForLinks () {
      const result = Utils.processTextsWithLinks([$scope.label, $scope.description])
      $scope.labelWithLinks = result[0]
      $scope.descriptionWithLinks = result[1]
    }

    handleNumberInputsScroll()
  }
})()
